<template>
  <div class="login">
    <h1>Login</h1>
    <a :href="loginUrl">Log in</a>
    |
    <a href="/dashboard">Go to dashboard</a>
    <div v-if="error" class="error">
      There was a problem logging in: {{errorDescription}}
    </div>
    <div v-if="authError">
      There was a problem logging in: {{authError}}
    </div>
  </div>
</template>

<script>
import { getExternalLoginLink } from '../utils/routing'
export default {
  data() {
    const x = {
      loginUrl: getExternalLoginLink(),
      error: !!this.$route.query.error,
      errorDescription: this.$route.query.error_description,
    }
    return x
  },
  computed: {
    authError() {
      return this.$store.state.authError && this.$store.state.authError.message
    }
  }
}
</script>

<style lang="stylus" scoped>
.error
  border 1px red solid
</style>
